var map = {
	"./luniu_logo.png": 676,
	"./salesForce_logo.png": 975,
	"./sellersCo_logo.png": 976,
	"./wholesale_logo.png": 977,
	"./wholesale_salesForce_logo.png": 978,
	"./wholesale_sellersCo_logo.png": 979
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 503;